import React from 'react';

import { Route, Switch } from 'react-router-dom';

import MessageFlowList from './MessageFlowList';
import MessageFlowEditor from './MessageFlowEditor';

const MessageFlow = ({ match }) => (
  <Switch>
    <Route exact path={`${match.url}/`} component={MessageFlowList} />
    <Route path={`${match.url}/editor/:id?`} component={MessageFlowEditor} />
  </Switch>
);

export default MessageFlow;
